




































import path from 'path';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { permissionModule } from '@/store/modules/ModulePermission';
import { tagsViewModule, ITagView } from '@/store/modules/ModuleTagsView';
import ScrollPane from './TagsScrollPane.vue';

@Component({
	name: 'TagsView',
	components: {
		ScrollPane
	}
})
/** docs */
export default class extends Vue {
	private visible: any = false;
	private top: any = 0;
	private left: any = 0;
	private selectedTag: ITagView = {};
	private affixTags: ITagView[] = [];

	/** document hooks */
	private get visitedViews(): any {
		return tagsViewModule.visitedViews;
	}

	/** document hooks */
	private get routes(): any {
		return permissionModule.routes;
	}

	/** document hooks */
	@Watch('$route')
	private onRouteChange(): any {
		this.addTags();
		this.moveToCurrentTag();
	}

	/** document hooks */
	@Watch('visible')
	private onVisibleChange(value: boolean): any {
		if (value) {
			document.body.addEventListener('click', this.closeMenu.bind(this));
		} else {
			document.body.removeEventListener('click', this.closeMenu.bind(this));
		}
	}

	/** document hooks */
	public mounted(): any {
		this.initTags();
		this.addTags();
	}

	/** document hooks */
	private isActive(route: ITagView): any {
		return route.path === this.$route.path;
	}

	/** document hooks */
	private isAffix(tag: ITagView): any {
		return tag.meta && tag.meta.affix;
	}

	/** document hooks */
	private filterAffixTags(routes: RouteConfig[], basePath: any = '/'): any {
		let tags: ITagView[] = [];

		routes.forEach((route: any): any => {
			if (route.meta && route.meta.affix) {
				const tagPath: any = path.resolve(basePath, route.path);

				tags.push({
					fullPath: tagPath,
					path: tagPath,
					name: route.name,
					meta: {
						...route.meta
					}
				});
			}

			if (route.children) {
				const childTags: any = this.filterAffixTags(route.children, route.path);

				if (childTags.length >= 1) {
					tags = [...tags, ...childTags];
				}
			}
		});

		return tags;
	}

	/** document hooks */
	private initTags(): any {
		this.affixTags = this.filterAffixTags(this.routes);
		for (const tag of this.affixTags) {
			// Must have tag name
			if (tag.name) {
				tagsViewModule.addVisitedView(tag);
			}
		}
	}

	/** document hooks */
	private addTags(): any {
		const { name }: any = this.$route;

		if (name) {
			tagsViewModule.addView(this.$route);
		}

		return false;
	}

	/** document hooks */
	private moveToCurrentTag(): any {
		// TODO: better typescript support for router-link
		const tags: any = this.$refs.tag as any[];

		this.$nextTick(() => {
			for (const tag of tags) {
				if (tag.to === this.$route.path) {
					const scrollPanel: any = this.$refs.scrollPane;

					scrollPanel(tag);
					// When query is different then update
					if (tag.to !== this.$route.fullPath) {
						tagsViewModule.updateVisitedView(this.$route);
					}

					break;
				}
			}
		});
	}

	/** document hooks */
	private refreshSelectedTag(view: ITagView): any {
		tagsViewModule.delCachedView(view);
		const { fullPath }: any = view;

		this.$nextTick(() => {
			// eslint-disable-next-line no-shadow
			const path: any = `/redirect${fullPath}`;

			this.$router
				.replace({
					path
				})
				['catch']((err: any): any => {
					console.warn(err);
				});
		});
	}

	/** document hooks */
	private closeSelectedTag(view: ITagView): any {
		tagsViewModule.delView(view);
		if (this.isActive(view)) {
			this.toLastView(tagsViewModule.visitedViews, view);
		}
	}

	/** document hooks */
	private closeOthersTags(): any {
		// eslint-disable-next-line no-undefined
		if (this.selectedTag.fullPath !== this.$route.path && this.selectedTag.fullPath !== undefined) {
			this.$router.push(this.selectedTag.fullPath)['catch']((err: any): any => {
				console.warn(err);
			});
		}

		tagsViewModule.delOthersViews(this.selectedTag);
		this.moveToCurrentTag();
	}

	/** document hooks */
	private closeAllTags(view: ITagView): any {
		tagsViewModule.delAllViews();
		if (this.affixTags.some((tag: any): any => tag.path === this.$route.path)) {
			return;
		}

		this.toLastView(tagsViewModule.visitedViews, view);
	}

	/** document hooks */
	private toLastView(visitedViews: ITagView[], view: ITagView): any {
		const latestView: any = visitedViews.slice(-1)[0];

		// eslint-disable-next-line no-undefined
		if (latestView !== undefined && latestView.fullPath !== undefined) {
			this.$router.push(latestView.fullPath)['catch']((err: any): any => {
				console.warn(err);
			});
		} else {
			// Default redirect to the home page if there is no tags-view, adjust it if you want
			// eslint-disable-next-line no-lonely-if
			if (view.name === 'Dashboard') {
				// to reload home page
				// eslint-disable-next-line no-shadow
				const path: any = `/redirect${view.fullPath}`;

				this.$router
					.replace({
						path
					})
					['catch']((err: any): any => {
						console.warn(err);
					});
			} else {
				this.$router.push('/')['catch']((err: any): any => {
					console.warn(err);
				});
			}
		}
	}

	/** document hooks */
	private openMenu(tag: ITagView, e: MouseEvent): any {
		const menuMinWidth: any = 105;
		// eslint-disable-next-line line-comment-position
		const offsetLeft: any = this.$el.getBoundingClientRect().left; // container margin left
		// eslint-disable-next-line line-comment-position
		const { offsetWidth }: any = this.$el as HTMLElement; // container width
		// eslint-disable-next-line line-comment-position
		const maxLeft: any = offsetWidth - menuMinWidth; // left boundary
		// eslint-disable-next-line line-comment-position
		const left: any = e.clientX - offsetLeft + 15; // 15: margin right

		if (left > maxLeft) {
			this.left = maxLeft;
		} else {
			this.left = left;
		}

		this.top = e.clientY;
		this.visible = true;
		this.selectedTag = tag;
	}

	/** document hooks */
	private closeMenu(): any {
		this.visible = false;
	}

	/** document hooks */
	private handleScroll(): any {
		this.closeMenu();
	}
}
